/**
 * Shared default column definition for all grids in FAIM2.
 *
 * Each page can override per-column. Keep this lean — only universally-desired defaults.
 */
import type { ColDef } from 'ag-grid-community';
import { displayGridValue } from '../ui/displayValue';

export const defaultColDef: ColDef = {
  filter: true,
  floatingFilter: true,
  resizable: true,
  sortable: true,
  minWidth: 100,
  valueFormatter: (params) => displayGridValue(params.value),
};
